import React, { Component } from 'react';

export default class Calculator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      house_price: '',
      deposit_percent_house_price: '',
      deposit_amount: '',
      deposit_percent_deposit_amount: '',
    };

    this.onChangeHousePrice = this.onChangeHousePrice.bind(this);
    this.onChangeDepositPercentHousePrice = this.onChangeDepositPercentHousePrice.bind(this);
    this.onChangeDepositAmount = this.onChangeDepositAmount.bind(this);
    this.onChangeDepositPercentDepositAmount = this.onChangeDepositPercentDepositAmount.bind(this);
    this.resetPriceForm = this.resetPriceForm.bind(this);
    this.resetDepositForm = this.resetDepositForm.bind(this);
    this.needsRounding = this.needsRounding.bind(this);
    this.deposit = this.deposit.bind(this);
  }

  onChangeHousePrice(e, name) {
    this.setState({ house_price: e.target.value.toLocaleString() });
  }

  onChangeDepositAmount(e, name) {
    this.setState({ deposit_amount: e.target.value.toLocaleString() });
  }

  onChangeDepositPercentHousePrice(e, name) {
    this.setState({
      deposit_percent_house_price: e.target.value <= 100 ? e.target.value : 100,
    });
  }
  onChangeDepositPercentDepositAmount(e, name) {
    this.setState({
      deposit_percent_deposit_amount: e.target.value <= 100 ? e.target.value : 100,
    });
  }

  resetPriceForm() {
    this.setState({
      house_price: '',
      deposit_percent_house_price: '',
    });
  }
  resetDepositForm() {
    this.setState({
      deposit_amount: '',
      deposit_percent_deposit_amount: '',
    });
  }

  needsRounding(number) {
    return number !== Math.round(number);
  }

  deposit(number, percent) {
    var value = number * percent;
    return this.needsRounding(value) ? parseFloat(value.toFixed(2)).toLocaleString() : value.toLocaleString();
  }

  render() {
    return (
      <div className="row">
        <div className="col-md-6 ">
          <div className="paper">
            <h2>Deposit needed</h2>
            <p>How much of a deposit do you need for your house</p>
            <div>
              <label>House Price ($): </label>
              <br />
              <input
                className="form-control"
                type="text"
                name="house_price"
                placeholder="enter house price"
                onChange={this.onChangeHousePrice}
                value={this.state.house_price.toLocaleString()}
              />
            </div>
            <div>
              <label>Custom Deposit (%): </label>
              <br />
              <input
                className="form-control"
                type="text"
                name="deposit_percent_house_price"
                placeholder="enter custom percentage"
                onChange={this.onChangeDepositPercentHousePrice}
                value={this.state.deposit_percent_house_price.toLocaleString()}
              />
            </div>
            <button onClick={this.resetPriceForm} className="btn btn-default">
              reset
            </button>
            {this.state.house_price !== '' && (
              <div>
                <h3>You need a deposit of:</h3>
                {this.state.deposit_percent_house_price && (
                  <div>
                    <label>{this.state.deposit_percent_house_price}% Deposit: </label>
                    <br />
                    <p style={{ color: 'green' }}>
                      ${this.deposit(this.state.house_price, this.state.deposit_percent_house_price / 100)}
                    </p>
                  </div>
                )}
                <div>
                  <label>20% Deposit: </label>
                  <br />
                  <p style={{ color: 'green' }}>${this.deposit(this.state.house_price, 0.2)}</p>
                </div>
                <div>
                  <label>10% Deposit: </label>
                  <br />
                  <p style={{ color: 'green' }}>${this.deposit(this.state.house_price, 0.1)}</p>
                </div>
                <div>
                  <label>5% Deposit: </label>
                  <br />
                  <p style={{ color: 'green' }}>${this.deposit(this.state.house_price, 0.05)}</p>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="col-md-6 ">
          <div className="paper">
            <h2>Price possible</h2>
            <p>What house can you afford with your current savings</p>
            <div>
              <label>Deposit Amount ($): </label>
              <br />
              <input
                type="text"
                placeholder="enter deposit amount"
                className="form-control"
                onChange={this.onChangeDepositAmount}
                value={this.state.deposit_amount}
              />
            </div>
            <div>
              <label>Custom Deposit (%): </label>
              <br />
              <input
                type="text"
                placeholder="enter custom percentage"
                className="form-control"
                onChange={this.onChangeDepositPercentDepositAmount}
                value={this.state.deposit_percent_deposit_amount}
              />
            </div>
            <button onClick={this.resetDepositForm} className="btn btn-default">
              reset
            </button>
            {this.state.deposit_amount && (
              <div>
                <h3>You can afford:</h3>
                {this.state.deposit_percent_deposit_amount && (
                  <div>
                    <label>With {this.state.deposit_percent_deposit_amount}% Deposit: </label>
                    <br />
                    <p style={{ color: 'green' }}>
                      ${this.deposit(this.state.deposit_amount, 100 / this.state.deposit_percent_deposit_amount)}
                    </p>
                  </div>
                )}
                <div>
                  <label>With 20% Deposit: </label>
                  <br />
                  <p style={{ color: 'green' }}>${this.deposit(this.state.deposit_amount, 100 / 20)}</p>
                </div>
                <div>
                  <label>With 10% Deposit: </label>
                  <br />
                  <p style={{ color: 'green' }}>${this.deposit(this.state.deposit_amount, 100 / 10)}</p>
                </div>
                <div>
                  <label>With 5% Deposit: </label>
                  <br />
                  <p style={{ color: 'green' }}>${this.deposit(this.state.deposit_amount, 100 / 5)}</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Calculator.jsx